import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { ValueSection } from './TrlMobileLabelValue.styles';

export const TrlMobileLabelValue = ({ label, children }) => (
  <ValueSection>
    <FormattedMessage id={label} />
    {children}
  </ValueSection>
);

TrlMobileLabelValue.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
};
